import { render, staticRenderFns } from "./DetailTag.vue?vue&type=template&id=08b0fb7a&scoped=true"
import script from "./DetailTag.vue?vue&type=script&lang=js"
export * from "./DetailTag.vue?vue&type=script&lang=js"
import style0 from "./DetailTag.vue?vue&type=style&index=0&id=08b0fb7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0fb7a",
  null
  
)

export default component.exports